import { InputHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return (
      <input
        ref={ref}
        className={clsx(
          'h-9 w-full bg-transparent hairline rounded-sm px-2 text-base text-ink placeholder:text-muted',
          'focus:outline-none focus:border-ink transition-colors duration-[120ms]',
          className,
        )}
        {...rest}
      />
    );
  },
);
